'use strict';

var $d = require('../dependency');
var constants = require('../constants');

var _ = $d._;

exports.findFilterIntervals = findFilterIntervals;

function findFilterIntervals(context, config, next) {
    var predefinedIntervals,
      dataKey,
      minValue,
      maxValue,
      lastInterval,
      returnFiltersArray = [],
      series;

    dataKey = config.dataKey;
    series = context.apiParsedResponseList[0][dataKey];
    minValue = series.length ? _.min(series) : 0;
    maxValue = series.length ? _.max(series) : 0;

    if ($d.env === constants.BROWSER) {
        predefinedIntervals = config.intervals;
        _.forEach(predefinedIntervals, function (singleInterval) {
            if (maxValue >= singleInterval.min) {
                returnFiltersArray.push(_.clone(singleInterval));
            }
        });

        lastInterval = returnFiltersArray[returnFiltersArray.length - 1];
        if (lastInterval.max === null || lastInterval.max > maxValue) {
            lastInterval.max = maxValue;
        } else if (lastInterval.max < maxValue) {
            returnFiltersArray.push({
                min: lastInterval.max,
                max: maxValue
            });
        }
        /**!ToDo may need to be added.**/
        // if (returnFiltersArray.length > 1) {
        //     returnFiltersArray.push({
        //         min: minValue,
        //         max: maxValue
        //     });
        // }

        context.returnFiltersArray = returnFiltersArray;
    } else {
        context.returnFiltersArray = [
            {
                min: 0,
                max: maxValue
            }
        ];
    }
    next();
}